import MUITableBody from '@mui/material/TableBody';
import React from 'react';

import { propsMapper } from '~/common/components/PropertyMappers/propsMapper';

type TbodyProps = {
  children?: React.ReactNode;
  classes?: any;
  component?: React.ReactNode;
  sx?: any;
} & React.HTMLAttributes<'tbody'>;

const Tbody = React.forwardRef<any, TbodyProps>(
  ({ children, ...props }, ref) => {
    return (
      <MUITableBody ref={ref} {...propsMapper(props)}>
        {children}
      </MUITableBody>
    );
  },
);

Tbody.displayName = 'Tbody';

export default Tbody;
